import { customEventNames, trackCustomEvent } from '@cinch/oxd-utils/analytics/src'

const hasWindow = typeof window !== 'undefined'
let deferredPrompt: any

export const initA2HS = (): void => {
  if (hasWindow) {
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt.
      // Prevent Chrome 76 and later from showing the mini-infobar.
      e.preventDefault()

      // Stash the event so it can be triggered later.
      deferredPrompt = e
    })

    window.addEventListener('appinstalled', () => {
      trackCustomEvent({ name: customEventNames.appInstalled })
    })
  }
}

export const isA2HSAvailable = (): boolean => !!deferredPrompt

export const triggerA2HS = (): void => {
  if (deferredPrompt) {
    // Show the install prompt.
    deferredPrompt.prompt()

    // Wait for the user to respond to the prompt.
    deferredPrompt.userChoice
      .then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          trackCustomEvent({ name: customEventNames.appInstallAccepted })
        } else {
          trackCustomEvent({ name: customEventNames.appInstallRejected })
        }

        // Reset the deferredPrompt variable, since prompt() can only be called once.
        deferredPrompt = null
      })
      .catch()
  }
}
